export const EVENT_NAME = "Tags Expanded";
